export default "__VITE_ASSET__DLUs7kIs__"